import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router";
import { App } from "~/ui/App";
import { useAuthStore } from "~/ui/auth/authStore";
import { configureApiClient } from "~/api/client";
import "./index.css";

// Initialize auth state from localStorage
useAuthStore.getState().hydrate();

// Configure API client with token getter
configureApiClient({
  getToken: () => useAuthStore.getState().accessToken,
  onRefresh: ({ accessToken, email, isAdmin }) =>
    useAuthStore.getState().setAuth(accessToken, email, isAdmin),
  onAuthFailure: () => useAuthStore.getState().clearAuth(),
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
    },
  },
});

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
